import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <span>AWS Exam Practice</span>
        <nav className="footer-links" aria-label="Footer links">
          <a href="#privacy">개인정보처리방침</a>
          <a href="#terms">이용약관</a>
          <a href="#contact">문의하기</a>
        </nav>
        <span className="footer-note">이 사이트는 Amazon Web Services와 공식적으로 연계되어 있지 않습니다.</span>
      </div>
    </footer>
  );
};

export default Footer;
